<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">Sélectionnez toutes les applications pratiques de la CCM:</p>

      <div v-for="option in options" :key="option.value" class="mb-0 pl-6">
        <v-checkbox
          v-model="inputs.applicationsTLC"
          class="d-inline-block my-0 py-1"
          :value="option.value"
          :dense="true"
          hide-details="true"
          :ripple="false"
        >
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-checkbox>
      </div>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import ChemicalLatex from '../displayers/ChemicalLatex';
import StembleLatex from '@/tasks/components/StembleLatex';
import DragToRankInput from '@/tasks/components/inputs/DragToRankInput.vue';

export default {
  name: 'uOttawa1321Prelab1Q6Fr',
  components: {
    DragToRankInput,
    ChemicalLatex,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        applicationsTLC: [],
      },
      options: [
        {text: 'Identifier un composé', value: 'identification'},
        {text: 'Faire une analyse quantitative d’une réaction', value: 'quantitativeAnalysis'},
        {text: 'Déterminer si une réaction est terminée', value: 'reactionCompletion'},
        {text: 'Vérifier la pureté d’un composé', value: 'verifyPurity'},
        {text: 'Toutes ces réponses', value: 'all'},
      ],
    };
  },
};
</script>
